import styled, { keyframes } from 'styled-components';

export const dotPulse = keyframes`
	0%,
	80%,
	100% {
		opacity: 0.35;
		transform: translateY(0);
	}

	40% {
		opacity: 1;
		transform: translateY(-3px);
	}
`;

export const PlaceholderWrapper = styled.div`
	display: flex;
	padding: 5px 0;
	width: 100%;
	justify-content: ${({ $alignRight }) => ($alignRight ? 'flex-end' : 'flex-start')};
`;

export const TypingDots = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
	min-height: 10px;
`;

export const TypingDot = styled.span`
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: rgba(255, 245, 255, 0.88);
	animation: ${dotPulse} 1.2s ease-in-out infinite;
	animation-delay: ${({ $delay }) => $delay}s;
`;

export const TypingLabel = styled.span`
	display: block;
	margin-top: 8px;
	font-size: 0.78rem;
	color: rgba(216, 189, 228, 0.72);
`;
